import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard, RouteType } from '@ecm/router';

import { BillsComponent } from './components/crossroad/bill/bills/bills.component';
import { ContractsAndOptionsComponent } from './components/crossroad/contract/contracts-and-options/contracts-and-options.component';
import { RemoveContractComponent } from './components/crossroad/contract/remove-contract/confirmation/remove-contract.component';
import { ContractSelectorComponent } from './components/crossroad/contract/remove-contract/selector/contract-selector.component';
import { DashboardContainerComponent } from './container/dashboard-container/dashboard-container.component';
import { BillsGuard } from './guards/bills.guard';
import { HomeGuard } from './guards/home.guard';
import { VisitorsGuard } from './guards/visitors.guard';

export const EcmDashboardRoutes: Routes = <Routes>[
    {
        path: 'accueil',
        canActivate: [AuthGuard, HomeGuard],
        data: {
            name: 'dashboard',
            carrousel: true,
            smartbanner: true,
        },
        children: [
            {
                path: '',
                component: DashboardContainerComponent,
            },
            {
                path: ':section',
                component: DashboardContainerComponent,
            },
        ],
    },
    {
        path: 'rattacher-un-contrat',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('./features/contract-attachment/contract-attachment.routing-module').then(
                (m) => m.ContractAttachmentRoutingModule,
            ),
    },
    {
        path: 'contrat-resilie',
        loadChildren: () =>
            import('./features/terminated-client-space/terminated-client-space.routing-module').then(
                (m) => m.TerminatedClientSpaceRoutingModule,
            ),
    },
    {
        path: 'page-accueil',
        canActivate: [VisitorsGuard],
        data: {
            name: 'hp-non-loggée',
            type: RouteType.VISITOR,
        },
        loadComponent: () =>
            import('./features/home-visitor/component/home-visitor.component').then((c) => c.HomeVisitorComponent),
    },
    {
        path: 'contrats-options',
        canActivate: [AuthGuard],
        component: ContractsAndOptionsComponent,
        data: {
            name: 'contrats-options',
        },
    },
    {
        path: 'retirer-contrat',
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                component: ContractSelectorComponent,
                data: {
                    name: 'remove-contracts',
                },
            },
            {
                path: ':cid',
                component: RemoveContractComponent,
                data: {
                    name: 'remove-contracts',
                },
            },
        ],
    },
    {
        path: 'factures-paiement',
        canActivate: [AuthGuard, BillsGuard],
        component: BillsComponent,
        data: {
            name: 'factures',
        },
    },
];

/**
 * @deprecated Routes are now registered in DefaultRoutingModule.
 * This module is kept for backward compatibility but will be removed in a future version.
 */
@NgModule({
    imports: [RouterModule.forChild([])],
    exports: [RouterModule],
})
export class EcmDashboardRouterModule {}
